import { supabase } from "@/lib/supabase/client";
import { requireUserId } from "@/features/identity/api/session";

export const ACTIVATION_ENTITLEMENT = "card_activation";

export async function getMyActivationEntitlement() {
  const uid = await requireUserId();
  const { data, error } = await supabase
    .from("entitlements")
    .select("id,entitlement_type,status")
    .eq("user_id", uid)
    .eq("entitlement_type", ACTIVATION_ENTITLEMENT)
    .eq("status", "active")
    .limit(1);
  if (error) throw error;
  return data[0] || null;
}
